import request from "../utils/request";

export const getSamples = '/sample/';
export const getSamplesDict = '/sample/dict';

export function addSamples(values: Array<any>) {
    return request.request({
        url: '/sample/',
        method: "post",
        data: values
    })
}

export function updateSample(values: any) {
    return request.put('/sample/', values);
}

export function deleteSample(id: number) {
    return request.delete('/sample/', {params: {sampleId: id}});
}

export function importSamples(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/sample/import', formData);
}

export const getSampleListByContractUrl = '/sample/byContract';